// Mirrors backend/utils/invoiceEdit.js so the UI shows the right controls.
const ADMIN_PRIMARY_ROLES = ['OW', 'sOW', 'OWp', 'RM'];

export function isOrg1AdminOrUp(user) {
  if (!user || user.isTemporaryProvider || user.organizationLevel !== 1) return false;
  return ADMIN_PRIMARY_ROLES.includes(user.primaryRole) || user.secondaryRoles?.admin === true;
}

export const canSeeCustomerCharge = isOrg1AdminOrUp;
export const canEditInvoiceFully = isOrg1AdminOrUp;

export function canAddInvoiceFees(job, user) {
  if (!job || !user || user.isTemporaryProvider) return false;
  if (canEditInvoiceFully(user)) return true;
  const userId = String(user._id || user.id || '');
  const driverId = job.driverId && (job.driverId._id || job.driverId);
  if (driverId && String(driverId) === userId) return true;
  if (user.organizationLevel === 2) {
    const vendor = user.vendorNumber || user.vendorId;
    const management = user.primaryRole === 'SP' || user.secondaryRoles?.admin === true || user.secondaryRoles?.dispatcher === true;
    return Boolean(vendor) && management && job.assignedVendorNumber === vendor;
  }
  return false;
}
